const { notEmptyValidator } = require('@/views/fusion/investment/intelligence-create/tools/form/validator');

const creative_name = {
  label: '创意名称',
  type: 'input',
  value: '',
  rules: {
    required: true,
    message: '请输入创意名称',
    trigger: ['change'],
    validator: notEmptyValidator,
  },
  word_list: ['自增序号', '素材名称', '素材id', '渠道号', '定向包名称'],
  props: {
    placeholder: '请输入创意名称',
  },
  isPreview: false,
};

const fusion__creative_num_type = {
  label: '广告分配创意数',
  type: 'radio-group',
  isButton: true,
  rules: {
    required: true,
    message: '请选择广告分配创意数',
    trigger: ['change'],
  },
  options: [
    {
      label: '指定数量',
      value: 'specify_num',
    },
  ],
  value: 'specify_num',
};

const fusion__creative_num = {
  label: ' ',
  type: 'input-number',
  hidden: false,
  rules: {
    required: true,
    message: '请输入渠道起始编号',
    trigger: ['change'],
  },
  props: {
    step: 1,
    min: 1,
    max: 10,
  },
  value: '',
};

export {
  creative_name, // 创意名称
  fusion__creative_num_type, // 广告分配创意数类型
  fusion__creative_num, // 广告分配创意数
};
